import { render, staticRenderFns } from "./ProductItemInventoryDelete.vue?vue&type=template&id=017b09c9&"
import script from "./ProductItemInventoryDelete.vue?vue&type=script&lang=js&"
export * from "./ProductItemInventoryDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports